import { useParams } from 'react-router-dom'

import type { RouteParams } from 'src/router/routes'

const _useParams = (): Readonly<Partial<RouteParams>> => {
  return useParams<RouteParams>()
}

export default _useParams
